module.exports = __webpack_public_path__ + "static/media/web.50f60837.png";